// Auth TLS certs are single-label wildcards, so the host stays one label deep.

// Two-label suffix; without it `iwoca.co.uk` would collapse to `co.uk`.
const MULTI_LABEL_SUFFIXES = ['co.uk'];

const getRegistrableDomain = (hostname: string): string => {
  const labelsToKeep = MULTI_LABEL_SUFFIXES.some((suffix) =>
    hostname.endsWith(`.${suffix}`),
  )
    ? 3
    : 2;

  return hostname.split('.').slice(-labelsToKeep).join('.');
};

export const getAuthBaseUrl = (): string => {
  if (import.meta.env.DEV || window.location.hostname === 'localhost') {
    // Relative: vite proxies it, cypress intercepts it.
    return '/auth';
  }

  // `hostname` not `host` so a port never leaks in.
  return `https://auth.${getRegistrableDomain(window.location.hostname)}`;
};
